import React from 'react'
import {ONTRAPORT} from 'organization/Event/Services/ServicesProvider'
import {
  OntraportTag,
  useTestTag,
} from 'organization/Event/Services/Apps/Ontraport/Config/Tags'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestOntraportTagButton(props: {
  tag: OntraportTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={ONTRAPORT} addTag={addTag} />
  )
}
